import _ from 'lodash';
// import xxtea from 'xxtea-node';
import * as types from '../mutation-types';
import api from '../../api/warehouse';

const state = {
  warehouses: [],
  shippingTypes: [],
  redemptionCenter: [],
  overseas: [],
};

const getters = {
  transportWarehouses: s => _.filter(s.warehouses, { type: 2 }),
  masterWarehouse: s => _.filter(s.warehouses, { type: 0 }),
};

const actions = {
  fetchWarehouse({ commit }) {
    return api.get().then(({ data: response }) => {
      commit(types.RECEIVE_WARAHOUSES, response.data);
    });
  },
  fetchShippingTypes({ commit }) {
    return api.shippingTypes().then(({ data: response }) => {
      commit(types.RECEIVE_SHIPPING_TYPES, response);
    });
  },
  fetchRedemptionCenter({ commit }) {
    return api.redemptionCenter().then(({ data: response }) => {
      commit(types.RECEIVE_REDEMPTION_CENTER, response.data);
    });
  },
  fetchOverseasWarehouse({ commit }) {
    return api.overseas().then(({ data: response }) => {
      commit(types.RECEIVE_OVERSEAS_WAREHOUSES, response.data);
    });
  },
};

/* eslint no-param-reassign: 0 */
const mutations = {
  [types.RECEIVE_WARAHOUSES](s, data) {
    s.warehouses = [...data];
  },
  [types.RECEIVE_SHIPPING_TYPES](s, data) {
    s.shippingTypes = [...data];
  },
  [types.RECEIVE_REDEMPTION_CENTER](s, data) {
    s.redemptionCenter = [...data];
  },
  [types.RECEIVE_OVERSEAS_WAREHOUSES](s, data) {
    s.overseas = [...data];
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/warehouse.js